var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 38,
    rx: 17,
    fill: "#071E3B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 9C27.2614 9 29.5 11.2386 29.5 14V24C29.5 26.7614 27.2614 29 24.5 29H14.5C11.7386 29 9.5 26.7614 9.5 24V14C9.5 11.2386 11.7386 9 14.5 9H24.5ZM19.5 14C16.7386 14 14.5 16.2386 14.5 19C14.5 21.7614 16.7386 24 19.5 24C22.2614 24 24.5 21.7614 24.5 19C24.5 16.2386 22.2614 14 19.5 14ZM19.5 16C21.1569 16 22.5 17.3431 22.5 19C22.5 20.6569 21.1569 22 19.5 22C17.8431 22 16.5 20.6569 16.5 19C16.5 17.3431 17.8431 16 19.5 16ZM25.5 12C24.9477 12 24.5 12.4477 24.5 13C24.5 13.5523 24.9477 14 25.5 14C26.0523 14 26.5 13.5523 26.5 13C26.5 12.4477 26.0523 12 25.5 12Z",
    fill: "#145DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.3947db5df8439242dfcd1dc34e09bbd2.svg";
export { ForwardRef as ReactComponent };